import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {fundType} from "../../../Models/Enums";

//import './StateManager.css';

/**
 * Affiche une icône indiquant la saisie manuelle ou le type de fonds de l'opération.
 * @param {object} props
 * @param {object} props.row
 * @param {boolean} [props.row.manual]
 * @param {Array<{ type: number }>} props.row.details
 */
export default function TableManualIndicator( props ) {
	if (props.row && props.row.hasOwnProperty("manual") && props.row.manual ) {
		return (
			<React.Fragment>
				<div className={`manual-line-indicator`}>
					<FontAwesomeIcon icon={["fas" , "hand-holding-usd"]} className={`display-5 manual-icon`} />
				</div>
			</React.Fragment>
		);
	}
	
	if( props.row.details[0].type < 4 ) {
		return (
			<React.Fragment>
				<div className={`manual-line-indicator`}>
					<FontAwesomeIcon icon={["fas" , "donate"]} className={`display-5 recycler-icon`} />
				</div>
			</React.Fragment>
		);
	}

	return (
		<React.Fragment>
			<div className={`manual-line-indicator`}>
				<FontAwesomeIcon icon={fundType.getIcon( props.row.details[0].type )} className={`display-5 recycler-icon`} />
			</div>
		</React.Fragment>
	);
}
